import WidgetWrapper from 'shared/components/atoms/WidgetWrapper/WidgetWrapper';

export default WidgetWrapper;
